
import { mapGetters, mapState } from 'vuex'
import cms from '~/mixins/common/cms'
import Meta from '~/mixins/meta'
export default {
    mixins: [cms, Meta],
    data() {
        return {
            isMobileScreen: false,
        }
    },
    head() {
        return {
            link: [
                {
                    rel: 'icon',
                    type: 'image/x-png',
                    href: `${
                        this.getLocaleLang(this.faviconIcon.image_path)
                            ? this.cmsImageLink({
                                  path: this.getLocaleLang(
                                      this.faviconIcon.image_path
                                  ),
                                  code: this.faviconIcon?.component_code,
                              })
                            : ''
                    }`,
                },
            ],
        }
    },
    computed: {
        ...mapState({
            menubars: (state) => state.cms.menus.menus,
            cms: (state) => state.cms.cms,
        }),
        ...mapGetters({
            faviconIcon: 'cms/faviconIcon',
        }),
    },
    created() {
        if (this.$vuetify.breakpoint.mobile) {
            this.$vuetify.breakpoint.mobile = false
        }
        this.$vuetify.theme.dark = true
    },
    async mounted() {
        if (this.menubars.length <= 0)
            this.$store.dispatch('cms/menus/getMenubars')

        if (this.cms.length <= 0) this.$store.dispatch('cms/cms', {})

        if (this.$cookie.get('token')) {
            this.socket = await this.$nuxtSocket({
                reconnection: false,
                auth: {
                    Authorization: `Bearer ${this.$cookie.get('token')}`,
                },
                transports: ['websocket'],
            })
            this.socket.on('disconnect', (e) => {
                setTimeout(() => {
                    this.socket.connect()
                }, 5000)
            })
            let reconnectCount = 0
            this.socket.on('connect_error', (e) => {
                if (reconnectCount < 3) {
                    setTimeout(() => {
                        this.socket.connect()
                    }, 5000)
                    reconnectCount++
                }
            })
            this.socket.on('playerBalance', (msg) => {
                this.$store.dispatch('player/totalBalanceSocket', msg)
            })
        }
    },
    methods: {
        onResize() {
            if (process.browser) {
                this.isMobileScreen = window.innerWidth < 1300
                this.$store.commit(
                    'themes/settings/setIsMobile',
                    this.isMobileScreen
                )
                return null
            }
            this.isMobileScreen = false
            this.$store.commit(
                'themes/settings/setIsMobile',
                this.isMobileScreen
            )
        },
        isTheme(themeValue = null) {
            // ? themeValue values, 1,2,3,null = default
            const theme = this.$config.THEME
            if (~~themeValue === 1) {
                return theme === 'theme-1'
            } else if (~~themeValue === 2) {
                return !theme || theme === 'theme-2'
            } else if (~~themeValue === 3) {
                return theme === 'theme-3'
            } else if (~~themeValue === 4) {
                return theme === 'theme-4'
            } else {
                return theme === 'theme-0'
            }
        },
    },
}
